export const createFileFromText = (text: string) => {
  const blob = new Blob([text], { type: 'text/plain' });
  const timestamp = new Date()
    .toISOString()
    .slice(0, 19)
    .replace(/:/g, '-');
  const fileName = `pasted-${timestamp}.txt`;
  const file = new File([blob], fileName, { type: 'text/plain' });
  return file;
};
